import React, { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import {decode as base64_decode} from 'base-64';
import useAuth from '../../hooks/useAuth';
import { useModuloControle } from '../../contexts/ModuloControleContext';
import { insertGTM, removeGTM } from '../Utilitarios/Funcoes';

const MENU_INICIAL_LOCAL_STORAGE_KEY = 'ddespMenuInicial';

const getMenuInicialCacheKey = (empresaId, usuarioId) => `${MENU_INICIAL_LOCAL_STORAGE_KEY}:${empresaId}:${usuarioId}`;

const lerMenuInicialPreferido = () => {
  const sessaoValida = sessionStorage.getItem('ddesp');

  if (!sessaoValida) {
    return null;
  }

  try {
    const sessao = JSON.parse(base64_decode(sessaoValida));
    const empresaId = Number(sessao?.[0] ?? 0);
    const usuarioId = Number(sessao?.[3] ?? 0);
    const parametrosConta = typeof sessao?.[39] === 'object' && sessao[39] !== null && !Array.isArray(sessao[39]) ? sessao[39] : {};
    const resgateXmlAtivo = parametrosConta?.['10'] !== false;
    const preferenciaSessao = parametrosConta?.menuInicial;
    const chave = empresaId && usuarioId ? getMenuInicialCacheKey(empresaId, usuarioId) : '';
    const preferenciaLocal = chave ? localStorage.getItem(chave) : null;
    const preferencia = preferenciaLocal ? JSON.parse(preferenciaLocal) : preferenciaSessao;
    const sessStorage = sessionStorage?.getItem('ddesp');
    const storage = JSON.parse(base64_decode(sessStorage));
    const menuInicial = storage[40]?.[0] ?? null;
    const MenuIniPreferDb = menuInicial ? JSON.parse(menuInicial.campo) : null;
    
    if(MenuIniPreferDb && MenuIniPreferDb.url){
      return {
        'modulo': Number(MenuIniPreferDb.modulo),
        'url': MenuIniPreferDb.url,
      }
    }

    if (!preferencia || preferencia.modo !== 'custom' || typeof preferencia.url !== 'string' || preferencia.url.trim() === '') {
      return null;
    }

    if (!resgateXmlAtivo && Number(preferencia.modulo) === 1) {
      return null;
    }

    return {
      modulo: Number(preferencia.modulo) === 1 ? 1 : 0,
      url: preferencia.url,
    };
  } catch (error) {
    return null;
  }
};

const GuestGuard = ({ children }) => {
  const { isLoggedIn } = useAuth();
  const {duplicidadeCadastro} = useModuloControle();
  const location = useLocation();

  const moduloAtual = Number(localStorage.getItem('moduloAtual'));
  const redirecionaPorModulo = {
    0: '/dashboard',
    1: '/resgate/dashboard',
  };

  useEffect(() => {
    const isCadastro = location.pathname.includes('cadastro');
    isCadastro ? insertGTM() : removeGTM();
  }, [location.pathname]);

  
  // PROTEÇÃO CONTRA LOOP: Verifica se sessionStorage foi limpo
  const sessaoValida = sessionStorage.getItem('ddesp');
  
  if (isLoggedIn && sessaoValida) {
    if (duplicidadeCadastro) {
      return <Redirect to={moduloAtual === 0 ? '/empresas' : '/resgate/empresas'} />;
    }
    const menuInicialPreferido = lerMenuInicialPreferido();

    if (menuInicialPreferido) {


      localStorage.setItem('moduloAtual', String(menuInicialPreferido.modulo));
      return <Redirect to={menuInicialPreferido.url} />;
    }

    const destino = redirecionaPorModulo[moduloAtual] || '/dashboard';
    return <Redirect to={destino} />;
  } 

  return <>{children}</>;
};

export default GuestGuard;
